import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';

const customer: AppRouteModule = {
  path: '/customer',
  name: 'Customer',
  component: LAYOUT,
  redirect: '/customer/index',
  meta: {
    icon: 'mdi:user-tie',
    title: '客户',
    hideChildrenInMenu: true,
    auth: 'customer',
    orderNo: 20,
  },
  children: [
    {
      path: 'index',
      name: 'CustomerIndex',
      component: () => import('/@/views/admin/customer/index.vue'),
      meta: {
        title: '客户列表',
        hideMenu: true,
        ignoreKeepAlive: false,
        setting: {
          action: 'index',
          controller: 'customer',
          module: 'crm',
          types: 'crm_customer',
        },
        auth: 'customer.index',
      },
    },
    {
      path: 'detail/:id',
      name: 'CustomerDetail',
      component: () => import('/@/views/admin/customer/CustomerDetail.vue'),
      meta: {
        title: '客户详情',
        hideMenu: true,
        currentActiveMenu: '/customer/index',
        ignoreKeepAlive: true,
        setting: {
          action: 'read',
          controller: 'customer',
          module: 'crm',
          types: 'crm_customer',
        },
        auth: 'customer.read',
      },
    },
  ],
};

export default customer;
